import qs from 'qs'

export const queryEventEntryPrevNextBySlug = (options: QueryBySlugPrevNextOptions) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      sort: [`sortKeyAsc:${options?.sortDir}`, 'title:asc'],
      pagination: {
        limit: 1
      },
      filters: {
        sortKeyAsc: {
          [options?.filter]: options?.filterValue
        }
      },
      fields: [
        ...queryFieldsPrevNext,
        'sortKeyAsc',
        'sortKeyDesc',
      ]
    },
    {
      encodeValuesOnly: true
    }
  )
  return `event-entries?${query}`
}
